<template>
	<div class="content-wrapper">
		<!-- Content -->
		<div class="container flex-grow-1 container-p-y">
			<!-- Change Password -->

			<div class="card mb-6">
				<h5 class="card-header">Votre compte Pika</h5>
				<div class="card-body pt-1" v-if="profile">
					<form id="formAccountSettings" method="GET" onsubmit="return false">
						<div class="row g-5 mb-6">
							<div class="col-md-6 form-password-toggle">
								<div class="input-group input-group-merge">
									<div class="form-floating form-floating-outline">
										<input
											class="form-control"
											type="text"
											id="newPassword"
											name="newPassword"
											v-model="profile.firstName"
											disabled  />
										<label for="newPassword">Prénom</label>
									</div>
								</div>
							</div>

							<div class="col-md-6 form-password-toggle">
								<div class="input-group input-group-merge">
									<div class="form-floating form-floating-outline">
										<input
											class="form-control"
											type="text"
											id="newPassword"
											name="newPassword"
											v-model="profile.lastName"
											disabled />
										<label for="newPassword">Nom</label>
									</div>
								</div>
							</div>

							<div class="col-md-12 form-password-toggle">
								<div class="input-group input-group-merge">
									<div class="form-floating form-floating-outline">
										<input
											class="form-control"
											type="text"
											id="newPassword"
											name="newPassword"
											v-model="profile.email"
											disabled />
										<label for="newPassword">Email</label>
									</div>
								</div>
							</div>

							<div class="col-md-12 form-password-toggle">
								<div class="input-group input-group-merge">
									<div class="form-floating form-floating-outline">
										<input
											class="form-control"
											type="text"
											id="newPassword"
											name="newPassword"
											v-model="profile.company"
											disabled />
										<label for="newPassword">Société</label>
									</div>
								</div>
							</div> 
						</div>
					</form>
				</div>
			</div>

			<div class="card mb-6">
				<h5 class="card-header">Modifier votre mot de passe</h5>
				<div class="card-body pt-1">
					<form id="formAccountSettings" method="GET" onsubmit="return false">
						<div class="row g-5 mb-6">
							<div class="col-md-6 form-password-toggle">
								<div class="input-group input-group-merge">
									<div class="form-floating form-floating-outline">
										<input
											class="form-control"
											type="password"
											id="newPassword"
											name="newPassword"
											placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
											v-model="password"
										/>
										<label for="newPassword">Nouveau mot de passe</label>
										<small v-if="errors.password" class="text-danger">{{ errors.password }}</small>
									</div>
								</div>
							</div>
							<div class="col-md-6 form-password-toggle">
								<div class="input-group input-group-merge">
									<div class="form-floating form-floating-outline">
										<input
											class="form-control"
											type="password"
											name="confirmPassword"
											id="confirmPassword"
											placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
											v-model="password2"
										/>
										<label for="confirmPassword">Confirmer nouveau mot de passe</label>
										<small v-if="errors.password2" class="text-danger">{{ errors.password2 }}</small>
									</div>
								</div>
							</div>
						</div>
						<div class="mt-6">
							<button type="submit" class="btn btn-primary me-3" @click="updatePassword()">Enregistrer</button>
						</div>
					</form>
				</div>
			</div>
		</div>
		<!-- / Content -->
		<div class="content-backdrop fade"></div>
	</div>
</template>

<script>
import HTTP from "@/axios";
import moment from "moment";
import "moment/locale/fr";

moment.locale("fr");

export default {
	name: "SettingsPage",

	data() {
		return {
			isLoading: true,
			profile: null,
			password: null,
			password2: null,
			errors: {},
		};
	},

	methods: {
		clearError(field) {
			// Supprime l'erreur pour le champ spécifié
			if (this.errors[field]) {
				delete this.errors[field];
			}
		},

		validateForm() {
			this.errors = {};

			if (!this.password) {
				this.errors.password = "Veuillez entrer un mot de passe valide.";
			}

			if (!this.password2) {
				this.errors.password2 = "Veuillez entrer un mot de passe de confirmation valide.";
			}

			if (this.password !== this.password2) {
				this.errors.password = "Les mots de passe ne correspondent pas";
			}
			
			return Object.keys(this.errors).length === 0;
		},

		async fetchProfile() {
			try {
				const response = await HTTP('/user/profile');

				this.profile = response.data.profile;
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || "Une erreur est survenue, merci de contacter contact@pika-aero.com";

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		},

		async updatePassword() {
			const validated = this.validateForm();

			if (!validated)
				return;

			try {
				await HTTP.post('/user/set-new-password', {
					password: this.password
				});

				this.password = "";
				this.password2 = "";

				// Alert user
				alert("Votre mot de passe à été modifié avec succès.");
			} catch (error) {
				alert("Impossible de changer le mot de passe, merci de contacter contact@pika-aero.com");
			}
		},

		formatDate(timestamp) {
			return moment.unix(timestamp).format("DD/MM/YYYY"); // Affiche "il y a 3 semaines"
		},

		formatRelativeDate(timestamp) {
			return moment.unix(timestamp).fromNow(); // Affiche "il y a 3 semaines"
		},
	},

	async mounted() {
		this.fetchProfile();
	}
};
</script>

<style scoped>
/* Ajoutez des styles spécifiques à la page Dashboard */
.dashboard {
	padding: 1rem;
}

.card-title {
	font-size: 1.2rem;
}

.card-text {
	margin: 0;
}

.load-center {
	display: block;
	margin: 0 auto;
}
</style>
